module.exports = __webpack_public_path__ + "img/2.5637c99d.jpg";